export function truncateObject(obj: any, currentDepth: number = 1, lengthTrigger = 20): any {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  if (Array.isArray(obj)) {
    if (obj.length > lengthTrigger && currentDepth <= 0) {
      return `[Truncated - ${obj.length} length array]`
    }
    return obj.map((item) => truncateObject(item, currentDepth - 1, lengthTrigger))
  }

  const keys = Object.keys(obj)
  if (keys.length > lengthTrigger && currentDepth <= 0) {
    return `{Truncated - ${keys.length} properties obj}`
  }

  return keys.reduce(
    (acc, key) => {
      acc[key] = truncateObject(obj[key], currentDepth - 1, lengthTrigger)
      return acc
    },
    {} as Record<string, any>,
  )
}
